import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { MeetingMediaObject } from '.';

export const useGetMeetingMediaQuery = (
	meetingId: string | undefined,
	enabled: boolean
): IQueryResponse<MeetingMediaObject[]> => {
	const fetchMeetingMedia = async (): Promise<MeetingMediaObject[]> => {
		if (!meetingId) {
			throw new Error('Meeting ID is required');
		}

		return APIService.getData<MeetingMediaObject[]>(`${APICONFIG.MEETING_MEDIA_URL}?meeting_event_c=${meetingId}`);
	};

	const { data, error, isLoading, isFetching, isPending, refetch } = useQuery({
		queryKey: ['MeetingMedia', meetingId],
		queryFn: fetchMeetingMedia,
		enabled: Boolean(meetingId && enabled),
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isFetching,
		isPending,
		refetch,
	};
};
